<!-- Start: Rejwan: 19-06-2025 Reporting -->
<template>
    <div class="">
        <div class="clearfix company-form-container-warapper"> <!-- Mustafijur: 01-06-2026: Removed company-form-container -->
            <div class="custom-loader-wrapper" v-if="loader">
                <div class="text-center">
                    <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                    <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                    <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

                </div>
            </div>

            <!-- Mustafijur: 01-06-2026: Start: Commented -->
            <!-- <div class="company-form-container-title-wrapper">
                <div class="col-sm-12 px-3 company-form-box-title">
                    <div class="trustee-nav-first">
                        <div class="trustee-nav-head">PF Master File</div>
                        <div class="trustee-nav-subhead">Select parameters below to generate and download report.</div>
                    </div>
                </div>
            </div> -->
            <!-- Mustafijur: 01-06-2026: End: Commented -->

            <div class="report-button-contents">
                <!-- Start: Rejwan: 02-07-2025 Reporting -->
                <!-- <div class="form-group col-md-4">
                    <label for="fiscal_year">Select Fiscal Year</label>
                    <b-form-select
                        v-model="selectedFiscalYear"
                        :options="fiscalYears"
                        class="mb-3"
                        id="fiscal_year"
                    ></b-form-select>
                </div>
                <div class="button_wrapper">
                    <button v-on:click="getReport()" class="btn btn-primary position-static">Download</button>
                </div> -->

                <!-- Mustafijur: 01-06-2026: Start: Commented -->
                <!-- <div class="report-button-contents d-flex align-items-center">
                    <div class="title mr-2">From Month</div>
                    <div class="value mr-2">
                        <b-form-select v-model="start_month">
                            <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                        </b-form-select>
                    </div>

                    <div class="title mr-2">From Year</div>
                    <div class="value mr-2">
                        <b-form-select v-model="start_year">
                            <b-form-select-option v-for="(year, n) in years" :key="n" :value="year">{{year}}</b-form-select-option>
                        </b-form-select>
                    </div>

                    <div class="title mr-2">To Month</div>
                    <div class="value mr-2">
                        <b-form-select v-model="end_month">
                            <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                        </b-form-select>
                    </div>

                    <div class="title mr-2">To Year</div>
                    <div class="value mr-2">
                        <b-form-select v-model="end_year">
                            <b-form-select-option v-for="(year, n) in years" :key="n" :value="year">{{year}}</b-form-select-option>
                        </b-form-select>
                    </div>
                    <button v-on:click="getReportWithValidation()" class="btn btn-primary position-static ml-2">Download</button>
                </div> -->
                <!-- Mustafijur: 01-06-2026: End: Commented -->
                <!-- End: Rejwan: 02-07-2025 Reporting -->
            </div>

            <!-- Mustafijur: 01-06-2026: Start -->
            <div class="row mt-4 no-margin">
                <div class="ibox col-md-12">
                    <div class="ibox-title dashboard_title px-0">
                        <h4 class="font-regular with-blue-text">Current Selected: <span>Yearly PF Leaver Statement Report</span></h4>
                        <h4>Select parameters below to generate and download report.</h4>
                    </div>
                    <div class="ibox-content px-0 trz_ppl_wrapper_2">

                        <div class="report-button-contents d-flex align-items-center">
                            <div class="title mr-2">From Month</div>
                            <div class="value mr-2">
                                <b-form-select v-model="start_month">
                                    <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                                </b-form-select>
                            </div>

                            <div class="title mr-2">From Year</div>
                            <div class="value mr-2">
                                <b-form-select v-model="start_year">
                                    <b-form-select-option v-for="(year, n) in years" :key="n" :value="year">{{year}}</b-form-select-option>
                                </b-form-select>
                            </div>

                            <div class="title mr-2">To Month</div>
                            <div class="value mr-2">
                                <b-form-select v-model="end_month">
                                    <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                                </b-form-select>
                            </div>

                            <div class="title mr-2">To Year</div>
                            <div class="value mr-2">
                                <b-form-select v-model="end_year">
                                    <b-form-select-option v-for="(year, n) in years" :key="n" :value="year">{{year}}</b-form-select-option>
                                </b-form-select>
                            </div>
                            <button v-on:click="getReportWithValidation()" class="btn btn-primary position-static ml-2">Download</button>
                        </div>

                    </div>
                </div>
            </div>
            <!-- Mustafijur: 01-06-2026: Ends -->


        </div>
    </div>
</template>

<script>


    export default{

        mounted() {
        },
        props: [],
        components: {

        },
        data(){

            return {

                empty_result : 'Please hold tight! We are preparing the report data for you!',
                loader: false,
                showoverlay : true,


                // Start: Rejwan: 02-07-2025 Reporting
                months: [
                    { value: "1", text: "January" },
                    { value: "2", text: "February" },
                    { value: "3", text: "March" },
                    { value: "4", text: "April" },
                    { value: "5", text: "May" },
                    { value: "6", text: "June" },
                    { value: "7", text: "July" },
                    { value: "8", text: "August" },
                    { value: "9", text: "September" },
                    { value: "10", text: "October" },
                    { value: "11", text: "November" },
                    { value: "12", text: "December" },
                ],

                start_year : '',
                currentYear: new Date().getFullYear(),
                currentMonth:new Date().getMonth(),
                start_month: '',
                start_month_name: '',
                end_month: '',
                end_year: '',
                // End: Rejwan: 02-07-2025 Reporting
            }
        },
        methods:{
            // Start: Rejwan: 02-07-2025 Reporting
            validateDateRange() {
                const start = new Date(this.start_year, this.start_month - 1);
                const end = new Date(this.end_year, this.end_month - 1);

                if (start > end) {
                this.$bvToast.toast('Invalid range: Start month is after end month.', {
                            title: "Error",
                            variant: "danger",
                            solid: true,
                            });
                return false;
                }

                this.errorMessage = '';
                return true;
            },

            getReportWithValidation() {
                if (this.validateDateRange()) {
                this.getReport();  // Your actual report generation function
                }
            },
            // End: Rejwan: 02-07-2025 Reporting

            getReport: function() {
                if (!this.checkNet()) return false;

                // Start: Rejwan: 02-07-2025 Reporting
                // if (!this.selectedFiscalYear) {
                //     alert('Please select a fiscal year');
                //     return false;
                // }
                // End: Rejwan: 02-07-2025 Reporting

                this.loader = true;
                let url = this.$api_url + '/pf/report/yearly/leaver';

                let formData = new FormData();
                 // Start: Rejwan: 02-07-2025 Reporting
                formData.append('start_year', this.start_year);
                formData.append('start_month', this.start_month);
                formData.append('end_year', this.end_year);
                formData.append('end_month', this.end_month);

                // formData.append('fiscal_year', this.selectedFiscalYear); // 👈 send fiscal year
                // End: Rejwan: 02-07-2025 Reporting

                this.downloadBlobResponse(
                    axios.post(url, formData, { responseType: 'blob' }),
                    'loader', // your loader key in this component
                    (data) => {
                        if (data.errors) {
                            this.$bvToast.toast(data.errors, {
                                title: 'Error',
                                variant: 'danger',
                                solid: true,
                            });
                        }
                    }
                );

                return false;
            },

            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');

                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
                }
                return val.join(' ');
            },

        },
        created: function(){


        },
        computed:
        {
            // Start: Rejwan: 02-07-2025 Reporting
            years () {
                const year = new Date().getFullYear();
                return Array.from({length: year - 2018}, (value, index) => year - index)
            },
            fiscalYears() {
                let startYear = 2020;
                let currentYear = new Date().getFullYear();
                let activeEndYear = new Date().getMonth() >= 6 ? currentYear + 1 : currentYear;
                let list = [{ value: null, text: 'Please select a fiscal year' }];
                for (let y = startYear; y <= activeEndYear; y++) {
                    let val = `${y}-${y + 1}`;
                    list.push({ value: val, text: val });
                }
                return list;
            }
            // End: Rejwan: 02-07-2025 Reporting
        }
    }
</script>

<!-- End: Rejwan: 19-06-2025 Reporting -->
